// extracted by mini-css-extract-plugin
export default {"header":"styles__header___QwsDG","aligned":"styles__aligned___CIkHe"};